const state = {
  sSuccess: '',
  sError: '',
  sWarning: '',
  sFixed: ''
}

const getters = {}

const actions = {
  setAlert ({ commit }, oMessage) {
    commit('setAlerts', oMessage)
    /* Depois de 3 segundos limpa a mensagem */
    setTimeout(function () {
      oMessage.sType = 'clean'
      commit('setAlerts', oMessage)
    }, 3000)
  }
}

const mutations = {
  /* Atualiza Item do carrinho */
  setAlerts (state, oMessage) {
    switch (oMessage.sType) {
      case 'success':
        state.sSuccess = oMessage.sInfo
        break
      case 'error':
        state.sError = oMessage.sInfo
        break
      case 'warning':
        state.sWarning = oMessage.sInfo
        break
      case 'fixed':
        state.sFixed = oMessage.sInfo
        break
      case 'clean':
        state.sSuccess = ''
        state.sError = ''
        state.sWarning = ''
        state.sFixed = ''
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
